export { default as Toggle } from 'catalogs/components/list/actions/CatalogsActionsToggle';
export { default as Edit } from 'catalogs/components/list/actions/CatalogsActionsEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/actions/index.js